import { render, staticRenderFns } from "./HSCodesTableMobile.vue?vue&type=template&id=4ff5c6d8&scoped=true"
import script from "./HSCodesTableMobile.vue?vue&type=script&lang=js"
export * from "./HSCodesTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff5c6d8",
  null
  
)

export default component.exports